/**
 * Récap des fautes de fin de partie, commun aux trois familles de jeux (modes à
 * vies, Speed Run, Défi du jour).
 *
 * Il s'insère AVANT les boutons d'action. Placé en fin de conteneur, il passait
 * sous « Rejouer » et « Voir le classement » : la plupart des joueurs relançaient
 * une partie sans avoir vu une seule de leurs erreurs, alors que c'est le seul
 * moment où le jeu enseigne quelque chose. L'ordre de lecture devient score,
 * puis fautes, puis quoi faire ensuite.
 *
 * @param {HTMLElement} container `.win-message`, `.loose-message` ou `.end-message`
 * @param {Array} errors entrées d'erreur du jeu
 * @param {Function} renderItem (error) => HTML d'une ligne
 * @param {string} title titre traduit du bloc
 */
/**
 * Enfant direct du conteneur devant lequel s'insère tout bloc de résultat : la
 * rangée d'actions quand elle existe, sinon le premier bouton rencontré.
 *
 * On remonte jusqu'à l'enfant direct : viser le bouton lui-même glisserait le
 * bloc À L'INTÉRIEUR de la rangée, entre les boutons, où il hériterait de leur
 * mise en ligne.
 */
export function endGameAnchor(container) {
    let anchor = container.querySelector(".message-actions, .btn");
    while (anchor && anchor.parentElement !== container) anchor = anchor.parentElement;
    return anchor;
}

export function renderErrorsRecap(container, errors, renderItem, title) {
    if (!container) return;

    // Retiré avant réécriture : un second appel (fin de partie puis relecture
    // du jour) empilerait sinon deux listes identiques.
    const existing = container.querySelector(".errors-recap");
    if (existing) existing.remove();
    if (!errors || errors.length === 0) return;

    const html = `
            <div class="errors-recap">
                <h3>${title}</h3>
                <div class="errors-list">${errors.map(renderItem).join("")}</div>
            </div>
        `;

    const anchor = endGameAnchor(container);

    if (anchor) anchor.insertAdjacentHTML("beforebegin", html);
    else container.insertAdjacentHTML("beforeend", html);
}
